import React from 'react';

const GOLD = '#d4af37';
const SERIF = "Georgia, 'Times New Roman', serif";

const TIERS = [
  {
    id: 'classes',
    tokens: '1 TOKEN',
    equals: '2 Classes',
    usd: '$5',
    perks: ['Includes Video Downloads', 'Access to recorded lectures and materials'],
  },
  {
    id: 'advanced',
    tokens: '6 TOKENS',
    equals: 'AI One-on-One Advanced Class',
    usd: '$30',
    perks: ['All topics covered', 'Instructed by the HumanCodex Minds', 'Personal AI tutoring session'],
  },
];

export default function PromptsSkillsPricing() {
  return (
    <section
      data-testid="prompts-skills-pricing"
      style={{ backgroundColor: '#0a0a0f', fontFamily: SERIF, borderTop: `1px solid ${GOLD}`, borderBottom: `1px solid ${GOLD}` }}
    >
      <div className="container mx-auto px-4 py-16 max-w-5xl text-center">
        <p className="text-[11px] font-mono uppercase tracking-[0.34em] mb-3" style={{ color: GOLD }}>
          The University's Token-Based Curriculum
        </p>
        <h2 className="text-3xl md:text-5xl font-bold mb-3" style={{ color: '#ffe9a8', fontFamily: SERIF }}>
          NextXus Prompts Skills
        </h2>
        <p className="text-sm md:text-base italic mb-10" style={{ color: '#f5f5f5', opacity: 0.8 }}>
          Tokens are currency. Knowledge is the product. 1 Token = $5 — the Token Standard.
        </p>

        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {TIERS.map((t) => (
            <div
              key={t.id}
              data-testid={`skills-tier-${t.id}`}
              className="p-8 rounded-lg text-left"
              style={{ border: `1px solid ${GOLD}`, backgroundColor: '#0a0a0f', boxShadow: '0 0 30px rgba(212,175,55,0.12)' }}
            >
              <p className="text-4xl font-bold" style={{ color: GOLD, fontFamily: SERIF }}>
                {t.tokens}
              </p>
              <p className="text-lg md:text-xl font-bold mt-1" style={{ color: '#ffe9a8' }}>
                = {t.equals}
              </p>
              <p className="text-sm mt-1 mb-4" style={{ color: '#f5f5f5', opacity: 0.6 }}>
                {t.usd} at the Token Standard
              </p>
              <ul className="space-y-2">
                {t.perks.map((p) => (
                  <li key={p} className="text-sm" style={{ color: '#f5f5f5', opacity: 0.9 }}>
                    <span style={{ color: GOLD }}>✦</span> {p}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <a
          href="https://next-xus.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="get-tokens-button"
          className="mt-10 inline-block px-10 py-4 rounded-md text-lg md:text-xl font-bold tracking-[0.14em] transition-transform hover:scale-[1.03]"
          style={{ backgroundColor: GOLD, color: '#0a0a0f', fontFamily: SERIF, border: '1px solid #f5e6b8', boxShadow: '0 0 40px rgba(212,175,55,0.3)' }}
        >
          GET TOKENS
        </a>
      </div>
    </section>
  );
}
